import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Image,
  Text,
  Box
} from '@chakra-ui/react';
import CopyGreenIcon from '../../../assets/copy-green-icon.svg';
import CopySuccessIcon from '../../../assets/copy-success-icon.svg';
import FacebookIcon from '../../../assets/facebook-icon.svg';
import LinkedinIcon from '../../../assets/linkedin-icon.svg';
import PinterestIcon from '../../../assets/pinterest-icon.svg';
import TwitterIcon from '../../../assets/twitter-icon.svg';
import WhatsappIcon from '../../../assets/whatsapp-icon.svg';
import CloseModalIcon from '../../../assets/close-modal-icon.svg';
import ShareSuccessImg from '../../../assets/done-circle-icon.svg';

import {
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share';
import Button from '../../Button';

function CreateRequestModal(props) {
  const { isOpen, onSubmit, title, shareUrl, titleBtn, onClose, media, bgColorOverlay } = props;

  const [isCopy, setIsCopy] = useState(false);

  const handleCopy = (value) => () => {
    if (!isCopy) {
      setIsCopy(true);
      setTimeout(() => {
        setIsCopy(false);
      }, 3000);
      if (value) navigator.clipboard.writeText(value);
    }
  };

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay backgroundColor={bgColorOverlay} />
      <ModalContent py={5} px={'15px'} w={'396px'} bgColor={'seasalt-white'} rounded={'12px'}>
        <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
          <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
            <p className="text-xl font-[800]">{title}</p>
            <Image
              className="w-[40px] h-[40px] cursor-pointer"
              src={CloseModalIcon}
              onClick={onSubmit}
              alt=""
            />
          </div>
        </ModalHeader>
        <ModalBody p={0}>
          <div className="flex flex-col items-center px-3 mt-6 mb-4">
            <img className="w-[48px] h-[48px]" src={ShareSuccessImg} alt="" />
            <p className="text-lg font-[600] mt-2">Your request has been submitted!</p>
            <p className="text-2xl font-[800] text-growth-green-500 mt-2 whitespace-nowrap">
              Share your Request!
            </p>
            <div className="flex items-center gap-4 mt-8">
              <p className="font-[600] text-sm text-black">Share:</p>
              <div className="flex items-center gap-3">
                <FacebookShareButton url={shareUrl} hashtag={'#twygs'}>
                  <Image
                    _hover={{
                      opacity: 0.8
                    }}
                    src={FacebookIcon}
                    alt="icon"
                  />
                </FacebookShareButton>
                <TwitterShareButton
                  url={shareUrl}
                  title={
                    'For readers who seek knowledge beyond the outrage cycle - my latest on Twygs'
                  }
                >
                  <Image
                    _hover={{
                      opacity: 0.8
                    }}
                    src={TwitterIcon}
                    alt="icon"
                  />
                </TwitterShareButton>
                <LinkedinShareButton url={shareUrl}>
                  <Image
                    _hover={{
                      opacity: 0.8
                    }}
                    src={LinkedinIcon}
                    alt="icon"
                  />
                </LinkedinShareButton>
                <WhatsappShareButton
                  url={shareUrl}
                  windowWidth={700}
                  title={
                    'For readers who seek knowledge beyond the outrage cycle - my latest on Twygs'
                  }
                  windowHeight={600}
                  separator=" "
                >
                  <Image
                    _hover={{
                      opacity: 0.8
                    }}
                    src={WhatsappIcon}
                    alt="icon"
                  />
                </WhatsappShareButton>
                <PinterestShareButton
                  description="twygs.io"
                  media={
                    media ||
                    `${process.env.REACT_APP_NEWSLETTER_URL}static/media/default-thumnail.ec3e32b29325b9a52a3c.png`
                  }
                  url={shareUrl}
                >
                  <Image
                    _hover={{
                      opacity: 0.8
                    }}
                    src={PinterestIcon}
                    alt="icon"
                  />
                </PinterestShareButton>
              </div>
            </div>
            <p className="text-[12px] text-02-dim-gray italic mt-3 text-center">
              To receive responses, make sure to share your request! Share it on social media for
              greater exposure, or copy the link below to send it directly to your audience.
            </p>
            <div className="p-2 mt-[10px] bg-05-seasalt-white rounded-[12px] flex items-center justify-between gap-4 w-full">
              <Text
                isTruncated
                w={'100%'}
                maxW={'220px'}
                lineHeight={'30px'}
                fontSize={'sm'}
                fontWeight={600}
                textColor={'#012BC2'}
                _hover={{ cursor: 'pointer' }}
              >
                <a target="_blank" href={shareUrl}>
                  {shareUrl}
                </a>
              </Text>
              <Box
                display={'flex'}
                alignItems={'center'}
                columnGap={'8px'}
                onClick={handleCopy(shareUrl)}
                cursor="pointer"
              >
                <Text fontSize={'sm'} fontWeight={900} color={'#4CAF50'}>
                  {isCopy ? 'Copied' : 'Copy'}
                </Text>
                <Image src={isCopy ? CopySuccessIcon : CopyGreenIcon} alt="" />
              </Box>
            </div>
          </div>
        </ModalBody>
        <ModalFooter w="100%" p="0">
          <Button onClick={onSubmit} className="w-full h-[42px]">
            {titleBtn}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default CreateRequestModal;
